export default __webpack_public_path__ + "static/media/Bubbly.14180745.mp3";